import { useEffect, useRef, useState } from "react"
import { DdpCta } from "@/components/shared/DdpCta"
import { CocktailList } from "@/components/shared/CocktailList"
import { useAppStore, useCmsStore } from "@/components/AppHooks"
import { CocktailBaseInfo } from "./cocktail-base-info"
import { CocktailIngredients } from "./cocktail-ingredients"
import { CocktailCraftMethods } from "./cocktail-craft-methods"
import { TCocktailDetailProps } from "../type"
import { styleName } from "@/config/const"
import { TopBack } from "@/components/shared/TopBack"
import { useRouter, useSearchParams } from "next/navigation"
import { SimnoffTopMarquee } from "@/components/shared/Smirnoff/TopMarquee"
import { CopyToClipboard, getCocktailInfo, GetLocale, getUrlQuery, UtilPrevBack } from "@/shared/utils"
import { TCocktail } from "@/shared/types"
import { tracking } from "@/shared/tracking"
import { SingleImg } from "@/components/shared/SingleImg"
import AppLoader from "@/components/AppLoader"

export function CocktailDetailsMaster(props: TCocktailDetailProps) {
  const downloadWrapperRef = useRef<HTMLDivElement>(null)
  const { storeConfig, localeData: {
    topLabelMaster,
    backCTAName,
    alterTopLabelWhatsYourCocktail
  } } = useCmsStore()!
  const {
    changeMlToOz
  } = storeConfig
  const noResult = props.searchParams.noResult === 'true'
  const [cocktailInfo, setCocktailInfo] = useState<TCocktail>()
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    if (!cocktailInfo) return
    document.title = cocktailInfo?.cocktailTitle || ''
  }, [cocktailInfo])
  const searchParams = useSearchParams()
  const cocktailId = searchParams?.get('cocktailId')
  useEffect(() => {
    if (!cocktailId) {
      window.location.replace(`/${GetLocale()}/error?type=cocktailNotFound&cocktailId=${cocktailId}`)
      return
    }
    tracking({
      "event": "pageView",
      "pagePath": location.pathname + location.search,
      "gatewayVersion": "v5"
    })

    getCocktailInfo([cocktailId]).then((cocktail) => {
      if (cocktail.length === 0) {
        window.location.replace(`/${GetLocale()}/error?type=cocktailNotFound&cocktailId=${cocktailId}`)
        return
      }
      setCocktailInfo(cocktail[0])
      setLoading(false)
      tracking({
        "event": "custom_event",
        "event_name": "view_recipe",
        "recipe_id": cocktailId,
        "recipe_name": cocktail[0].cocktailTitle,
        "brand": cocktail[0].brandName
      })
    })

  }, [cocktailId])
  const { results } = useAppStore()
  const [copied, setCopied] = useState(false)
  const isSmirnoff = props.storeStyleName === styleName.SmirnoffKenya
  const [_, setSelectedPersons] = useState<number>(1)
  async function downloadHandler() {
    if (downloadWrapperRef.current !== null && cocktailInfo) {
      CopyToClipboard(location.href)
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 2000)
      // setDownloading(true)
      // downloadPdf({
      //   cocktailInfo,
      //   storeConfig,
      //   selectedPersons,
      //   pageProps: props
      // }).finally(() => {
      //   setDownloading(false)
      // })
    }
  }
  const router = useRouter()
  return <> <div className={`${isSmirnoff ? 'page-smirnoff-cocktail-details' : 'page-cocktail-details'} `}>
    {
      isSmirnoff && <SimnoffTopMarquee />
    }

    <div className="smirnoff-page-container page-container">
      <div className="top-logo" onClick={() => {
        const params = new URLSearchParams(location.search);
        params.delete('cocktailId');
        params.delete('noResult');
        const query = params.toString();
        window.location.replace(`/${GetLocale()}/home${query ? '?' + query : ''}`)
      }}>
        {
          isSmirnoff ? <SingleImg className="img" image={alterTopLabelWhatsYourCocktail} /> : topLabelMaster
        }

      </div>
      {
        <TopBack onClick={() => {
          UtilPrevBack().then((res) => {
            if (res) {
              const params = new URLSearchParams(location.search);
              params.delete('cocktailId');
              params.delete('noResult');
              const query = params.toString();
              router.replace(`/${GetLocale()}/results${query ? '?' + query : ''}`)
              // router.back()
            }
          })
        }} >
          <span>{backCTAName}</span>
        </TopBack>
      }

    </div>
    <div className="download-wrapper" ref={downloadWrapperRef}>
      {
        cocktailInfo && cocktailId === cocktailInfo?.id && <><CocktailBaseInfo {...props} cocktailInfo={cocktailInfo} >
          <DdpCta className="download-cta" cta={{
            show: props.downloadCTA[0].show,
            text: !copied ? props.downloadCTA[0].text : props.linkCopied,
            url: ''
          }} onClick={downloadHandler} disabled={copied} >
            {/* {
              !copied && <IconDownload />
            } */}
          </DdpCta>
        </CocktailBaseInfo>
          <CocktailIngredients key={cocktailInfo.id} {...props} cocktailInfo={cocktailInfo} changeMlToOz={changeMlToOz} onChangeSelectedPersons={setSelectedPersons} />
          <CocktailCraftMethods {...props} cocktailInfo={cocktailInfo} />
        </>
      }

    </div>
    {
      cocktailInfo && cocktailId === cocktailInfo?.id && results && !noResult && <div className="cocktail-similar-wrapper">
        <h2 className="similar-title sub-title">{props.titleSimilarCocktails}</h2>
        <div className="similar-cocktails-wrapper">
          <CocktailList cocktailList={results?.cocktailRecommendations.filter((item) => item.cocktailId !== cocktailId).slice(0, 3)} cta={props.cTANameSimilarCocktails} />
        </div>
      </div>
    }
  </div>
    {
      loading && <AppLoader />
    }
  </>
}
